export function latestPartners(state) {
    return [...state.partners].sort((a, b) => a.created - b.created).slice(-10);
}

export function transactions(state) {
    return state.transactions;
}

export function transactionsLoading(state) {
    return state.transactionsLoading;
}

export function transactionsTotal(state) {
    return state.transactionsTotal;
}

export function transactionsSums(state) {
    return state.transactionsSums;
}
